import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const PurchaseBookList = createAsyncThunk(
  "Purchase/PurchaseBookList",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseBookList`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const PurchaseAcList = createAsyncThunk(
  "Purchase/PurchaseAcList",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseAcList`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
          SubBookIDs: data.SelectSubBookIDs ? data.SelectSubBookIDs : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const PurchaseSubBook = createAsyncThunk(
  "Purchase/PurchaseSubBook",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseSubBook`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const PurchaseItemList = createAsyncThunk(
  "Purchase/PurchaseItemList",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseItemList`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const Purchase = createAsyncThunk("Purchase/Purchase", async (data) => {
  console.log(data);

  try {
    const response = await axios.post(
      `${BaseURL}/Purchase/Purchase`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        BookIDs: data.BookIDs ? data.BookIDs : "",
        AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
        StartDate: data.selectestartdate ? data.selectestartdate : "",
        EndDate: data.selectenddate ? data.selectenddate : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const PurchaseAnalysis = createAsyncThunk(
  "Purchase/PurchaseAnalysis",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseAnalysis`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);
export const PurchaseAnalysisCombination = createAsyncThunk(
  "Purchase/PurchaseAnalysisCombination",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseAnalysisCombination`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
          ItemIDs: data.selectItemIds ? data.selectItemIds : "",
          SubBookIDs: data.selecteSubBookdIds ? data.selecteSubBookdIds : "",
          // SubBookIDs: "34861",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const PurchaseDashboard = createAsyncThunk(
  "Purchase/PurchaseDashboard",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseDashboard`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
          SubBookIDs: data.selecteSubBookdIds ? data.selecteSubBookdIds : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const PurchaseBookMonthDtl = createAsyncThunk(
  "Purchase/PurchaseBookMonthDtl",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseBookMonthDtl`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
          SubBookIDs: data.selecteSubBookdIds ? data.selecteSubBookdIds : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          Month: data.selectmonthname ? data.selectmonthname : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);
export const PurchaseBookSubBookParty = createAsyncThunk(
  "Purchase/PurchaseBookSubBookParty",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/Purchase/PurchaseBookSubBookParty`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BookIDs: data.BookIDs ? data.BookIDs : "",
          SubBookIDs: data.selecteSubBookdIds ? data.selecteSubBookdIds : "",
          Month: data.Month ? data.Month : "",
          AcIDs: data.selectSalepartyIds ? data.selectSalepartyIds : "",
          StartDate: data.selectestartdate ? data.selectestartdate : "",
          EndDate: data.selectenddate ? data.selectenddate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  }
);

export const purchaseslice = createSlice({
  name: "purchaseslice",
  initialState: {
    PurchaseBookListdata: null,
    PurchaseAcListtdata: null,
    Purchasedata: null,
    PurchaseAnalysisdata: null,
    PurchaseSubBookdata: null,
    PurchaseItemListdata: null,
    PurchaseAnalysisCombinationdata: null,
    PurchaseDashboarddata: null,
    PurchaseBookMonthDtldata: null,
    PurchaseBookSubBookPartydata: null,

    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PurchaseBookList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseBookList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseBookListdata = action.payload;
      })
      .addCase(PurchaseBookList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(PurchaseAcList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseAcList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseAcListtdata = action.payload;
      })
      .addCase(PurchaseAcList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(Purchase.pending, (state) => {
        state.status = "loading";
      })
      .addCase(Purchase.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.Purchasedata = action.payload;
      })
      .addCase(Purchase.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(PurchaseAnalysis.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseAnalysis.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseAnalysisdata = action.payload;
      })
      .addCase(PurchaseAnalysis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(PurchaseSubBook.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseSubBook.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseSubBookdata = action.payload;
      })
      .addCase(PurchaseSubBook.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(PurchaseItemList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseItemList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseItemListdata = action.payload;
      })
      .addCase(PurchaseItemList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(PurchaseAnalysisCombination.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseAnalysisCombination.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseAnalysisCombinationdata = action.payload;
      })
      .addCase(PurchaseAnalysisCombination.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

    builder
      .addCase(PurchaseDashboard.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseDashboard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseDashboarddata = action.payload;
      })
      .addCase(PurchaseDashboard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    builder
      .addCase(PurchaseBookMonthDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseBookMonthDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseBookMonthDtldata = action.payload;
      })
      .addCase(PurchaseBookMonthDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
    builder
      .addCase(PurchaseBookSubBookParty.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PurchaseBookSubBookParty.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PurchaseBookSubBookPartydata = action.payload;
      })
      .addCase(PurchaseBookSubBookParty.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default purchaseslice.reducer;
